import styled from "@emotion/styled";
import { SkeletonBlock } from "components/general/Skeleton";
import { useIsMobile } from "hooks/useDeviceType";
import { useIsTradeHistoryReturned } from "hooks/useIsTradeHistoryReturned";
import { useCallback } from "react";
import { arbitrum, mainnet, polygon } from "wagmi/chains";
import { ReactComponent as Arbitrum } from "../../../img/trade-history/arbitrum.svg";
import { ReactComponent as Ethereum } from "../../../img/trade-history/ethereum.svg";
import { ReactComponent as Polygon } from "../../../img/trade-history/polygon.svg";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { TransactionDetail } from "../../../types/history";

export const NetworkCell = ({ chainId }: { chainId: TransactionDetail["chain_id"] }) => {
  const theme = GlobalStore.useState(s => s.theme);
  const isMobile = useIsMobile();
  const iconSize = isMobile ? 16 : 20;
  const isTradeHistoryReturned = useIsTradeHistoryReturned();

  const iconByNetwork = useCallback(
    (networkId: number) => {
      if (networkId === mainnet.id) {
        return <Ethereum color={theme.Networks.Ethereum} width={iconSize} height={iconSize} />;
      } else if (networkId === polygon.id) {
        return <Polygon color={theme.Networks.Polygon} width={iconSize} height={iconSize} />;
      } else if (networkId === arbitrum.id) {
        return <Arbitrum color={theme.Networks.Arbitrum} width={iconSize} height={iconSize} />;
      }
    },
    [iconSize, theme.Networks.Arbitrum, theme.Networks.Ethereum, theme.Networks.Polygon]
  );

  return (
    <Container iconSize={iconSize}>
      {isTradeHistoryReturned ? iconByNetwork(chainId) : <SkeletonBlock />}
    </Container>
  );
};

// Sub-components

interface ContainerProps {
  iconSize: number;
}

export const Container = styled.div<ContainerProps>(({ iconSize }) => ({
  width: `${iconSize}px`,
  height: `${iconSize}px`,
  lineHeight: 1,
}));
